import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import getVideoId from "get-video-id"
import ScrollAnimation from "react-animate-on-scroll"
import {
  UserObjectStoreProvider,
  SaveItem,
  getUserobjectData,
  isAuthenticated,
  savedSearchParams,
} from "@myaccount/website-service"

import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform"
import SearchResultsImagePopup from "@Components/SearchResults/SearchResultsImagePopup2"
import SearchResultsFloorplanPopup from "@Components/SearchResults/SearchResultsFloorplanPopup"
import PlayVideo from "@Components/PlayVideo/PlayVideo"

import imageConfig from "../../../static/images/config.json"
import NoImage from "../../images/no-image.png"
import resultLogo1 from "../../images/result-logo-1.jpg"
//import { NoNewHomes } from "../../queries/common_use_query"
import NewHomesLink from "../SearchResults/NewHomesLink"

import { capitalize } from "lodash"
import { isArray } from "@apollo/client/cache/inmemory/helpers"

const BotNewHomesPropertyList = props => {
  // Video
  const [isPlay, setIsPlay] = useState(false)
  const [videoid, setVideoId] = useState("")
  const [video_type, setVideoType] = useState("")
  const [hits, setHits] = useState([])

  //const { loading, error, data } = NoNewHomes()

  const playVideoHandler = (video_url, video_type) => {
    setIsPlay(true)
    setVideoId(video_url)
    setVideoType(video_type)
  }

  const [show, setShow] = useState(false)
  const [fullscreen, setFullscreen] = useState(true)

  function handleShow(video_url, video_type) {
    setShow(true)
    setVideoId(video_url)
    setVideoType(video_type)
  }
  // Video

  useEffect(() => {
    setHits(props.hits)
  }, [props.hits])

  return (
    <React.Fragment>
      {hits?.length > 0 &&
        hits.map((hit, i) => {
          // property details url structure
          let uriStr = ""
          let mysale = ""

          uriStr = `new-home-for-sale/`
          // property details url structure

          // Video id
          let videotourid = hit.video_tour ? Array.isArray(hit.video_tour) ? getVideoId(hit.video_tour[0].url) : getVideoId(hit.video_tour) : ""

          let virtualid = hit.virtual_url ? Array.isArray(hit.virtual_url) ? getVideoId(hit.virtual_url[0].url) : getVideoId(hit.virtual_url) : ""
          // Video

          // ggfx images
          let processedImages = JSON.stringify({})
          if (hit?.imagetransforms?.images_Transforms) {
            processedImages = hit.imagetransforms.images_Transforms
          }

          return (
            <>
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                <div className="property-card-detailed">
                  <div className="property-img">
                    <Link to={`/${uriStr}${hit.slug}-${hit.id}`}>
                      {hit?.images && hit?.images?.length > 0 ? (
                        <ImageTransform
                          imagesources={hit?.images[0]?.url}
                          renderer="srcSet"
                          imagename="new-developments.images.similar_homes"
                          attr={{
                            alt: hit?.display_address + " -  DNG",
                          }}
                          imagetransformresult={processedImages}
                          id={hit.id}
                        />
                      ) : (
                        <img src={NoImage} alt="property" />
                      )}
                    </Link>

                    <div className="property-wrapper">
                      <div className="left-block">
                        {/* <div className="image-wrap">
                                                    <i className="icon-camera"></i>
                                                    {
                                                        hit.thumbnail &&
                                                        <div className="image-count">1/{hit.thumbnail.length}</div>
                                                    }                                                
                                                </div> */}
                        {hit?.images && hit?.images?.length != 0 && (
                          <SearchResultsImagePopup
                            propertyId={hit.id}
                            propertyImage={hit?.images}
                            department="new_homes"
                          />
                        )}

                        <div className="property-view">
                          {/* <div className="video-wrap">
                                                        <button>
                                                            <i className="icon-play"></i>
                                                        </button>
                                                    </div> */}

                          {hit.video_tour &&
                            (videotourid?.service === "youtube" ? (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    playVideoHandler(hit.video_tour, "youtube")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ) : (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    handleShow(hit.video_tour, "custom_video")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ))}

                          {hit.virtual_url &&
                            (virtualid?.service === "youtube" ? (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    playVideoHandler(hit.virtual_url, "youtube")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ) : (
                              <div className="video-wrap">
                                <button
                                  onClick={() =>
                                    handleShow(hit.virtual_url, "custom_video")
                                  }
                                >
                                  <i className="icon-play"></i>
                                </button>
                              </div>
                            ))}

                          {hit?.floorplan?.url && (
                            <SearchResultsFloorplanPopup
                              propertyId={hit.id}
                              propertyFloorPlan={hit?.floorplan}
                            />
                          )}
                        </div>
                      </div>
                      {/* <div className="right-block">
                        <button>
                          <i className={"icon-heart"} />
                          <span className="span-btn-text">{"save"}</span>
                        </button>
                      </div> */}
                    </div>
                    {hit.status &&
                      hit.status !== "For Sale" &&
                      hit.status !== "To Let" && (
                        <div className="property-tag">{hit.status}</div>
                      )}
                  </div>
                  <div className="property-details">
                    <div className="name-wrap">
                      <div className="property-name">
                        <Link to={`/${uriStr}${hit.slug}-${hit.id}`}>
                          {hit.display_address &&
                            hit.display_address.replace(/,,/g, ",")}
                          {/*<br className="d-none d-xl-block" />{'test2'}*/}
                        </Link>
                      </div>
                      <div className="img-wrap">
                        <img src={resultLogo1} alt="logo" />
                      </div>
                    </div>
                    <p>
                      {hit.title && `${capitalize(hit.title)}`}
                      {parseInt(hit?.available) > 0 && (
                        <span className="available-properties">
                          ${hit.available} Available
                        </span>
                      )}
                    </p>
                    <div className="property-price">
                      {" "}
                      {hit?.price_qualifier === "POA"
                        ? "€ Price on Application"
                        : hit.price > 0
                        ? `€${parseFloat(hit.price).toLocaleString()} ${
                            hit?.search_type === "lettings" &&
                            hit?.price_qualifier
                              ? hit?.price_qualifier
                              : ""
                          }
                          `
                        : hit?.search_type !== "lettings" &&
                          hit?.price_qualifier &&
                          hit?.price_qualifier}
                    </div>
                    {hit.description && (
                      <p className="more-info">{hit.description}</p>
                    )}
                    <div className="links-block">
                      <div className="link-wrap">
                        <Link to={`/${uriStr}${hit.slug}-${hit.id}`}>
                          View Details
                          <i className="icon-arrow"></i>
                        </Link>
                      </div>
                      <NewHomesLink
                        hit={hit}
                        pro_url={`/${uriStr}${hit.slug}-${hit.objectID}`}
                      />

                      {/* <div className="link-wrap">
                                                <Link to="/">
                                                    Register Your Interest
                                                    <i className="icon-arrow"></i>
                                                </Link>
                                            </div>
                                            <div className="link-wrap">
                                                <a href="tel:719159222">
                                                    <i className="icon-phone"></i>
                                                    071 915 9222
                                                </a>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </ScrollAnimation>
            </>
          )
        })}
    </React.Fragment>
  )
}

export default BotNewHomesPropertyList
